import { useMutation } from '@occc-app/dataAccessLayer/utils';
import { useScanDataSubmitWeeklyFileMutation } from '@occc/graphql';

export const useScanDataSubmitWeeklyFile = () => useMutation(useScanDataSubmitWeeklyFileMutation);
